import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import cud from './slices/cudSlice'
/** REF **/
import unit_kerja from "./slices/ref/unitKerjaSlice";
import tarif_upah from "./slices/ref/tarifUpahSlice";
import tarif_shift from "./slices/ref/tarifShiftSlice";
import potongan from "./slices/ref/potonganSlice";
import tunjangan from "./slices/ref/tunjanganSlice";
import tali_asih from "./slices/ref/taliAsihSlice";
import kota from "./slices/ref/kotaSlice";
import bank from "./slices/ref/bankSlice";
import hari_libur from "./slices/ref/hariLiburSlice";
import persentase_biaya from "./slices/ref/persentaseBiayaSlice";
import kelompok_tenaga from "./slices/ref/kelompokTenagaSlice";
import lokasi_kerja from "./slices/ref/lokasiKerjaSlice";
import kualifikasi from "./slices/ref/kualifikasiSlice";
import kode_ok from "./slices/ref/kodeOKSlice";
import nomor_ok from "./slices/ref/nomorOKSlice";
import perusahaan_subkon from "./slices/ref/perusahaanSubkonSlice";
import lokasi_shift from "./slices/ref/lokasiShiftSlice";
import dokumen from "./slices/ref/dokumenSlice";
import ter from "./slices/ref/terSlice";

/** TRANSAKSI **/

import pegawai from "./slices/pegawaiSlice"
import lembur from "./slices/lemburSlice";
import pengajuan_lembur from "./slices/pengajuanLemburSlice";
import rekap_lembur from "./slices/rekapLemburSlice";
import pengajuan_gaji from "./slices/pengajuanGajiSlice";
import tagihan from "./slices/tagihanSlice";
import tagihan_biaya from "./slices/tagihanBiayaSlice";
import tunjangan_lain from "./slices/tunjanganLainSlice";
import presensi from "./slices/presensiSlice";
import presensi_proyek from "./slices/presensiProyekSlice";
import potongan_keterlambatan_proyek from "./slices/potonganKeterlambatanProyekSlice";
import keterlambatan_proyek from "./slices/keterlambatanProyekSlice";
import project from "./slices/projectSlice";
import riwayat_pengajuan from "./slices/riwayatPengajuanSlice";
import sppd_proyek from "./slices/sppdProyekSlice";
import pengajuan_tagihan from "./slices/pengajuanTagihanSlice";
import pengajuan_tagihan_proses from "./slices/pengajuanTagihanProsesSlice";
import pengajuan_tagihan_biaya_lainnya from "./slices/pengajuanTagihanBiayaLainnyaSlice";
import dashboard from "./slices/dashboardSlice";
import project_pegawai from "./slices/projectPegawaiSlice";
import shift from "./slices/shiftSlice";
import pegawai_shift from "./slices/pegawaiShiftSlice";
import pegawai_subkon from "./slices/pegawaiSubkonSlice";
import pegawai_dokumen from "./slices/pegawaiDokumenSlice";
import subkon_mangkir from "./slices/subkonMangkirSlice";
import operasional_biaya_lainnya from "./slices/operasionalBiayaLainnyaSlice";
import pengajuan_gaji_proses from "./slices/pengajuanGajiProsesSlice";
import gaji_potongan from "./slices/gajiPotonganSlice";
import gaji_pph21 from "./slices/gajiPph21Slice";
import shift_jadwal from "./slices/shiftJadwalSlice";
import exit_clearence from "./slices/exitClearenceSlice";

/** PENGATURAN **/
import pengguna from './slices/pengaturan/PenggunaSlice'
import pengawas from './slices/pengaturan/pengawasSlice'
import pengguna_pekerjaan_tagihan from './slices/pengaturan/PenggunaPekerjaanTagihanSlice'
import pengguna_rhi_kode_ok from './slices/pengaturan/PenggunaRHIKodeOKSlice'

/* REPORTS */
import estimasi_ok from './slices/reports/estimasiOkSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        bank,
        cud,
        dashboard,
        estimasi_ok,
        exit_clearence,
        gaji_potongan,
        gaji_pph21,
        hari_libur,
        kelompok_tenaga,
        keterlambatan_proyek,
        kode_ok,
        kota,
        kualifikasi,
        lembur,
        lokasi_kerja,
        lokasi_shift,
        dokumen,
        nomor_ok,
        operasional_biaya_lainnya,
        perusahaan_subkon,
        pegawai,
        pegawai_shift,
        pegawai_subkon,
        pegawai_dokumen,
        pengajuan_gaji,
        pengajuan_gaji_proses,
        pengajuan_lembur,
        pengajuan_tagihan,
        pengajuan_tagihan_proses,
        pengajuan_tagihan_biaya_lainnya,
        pengawas,
        pengguna,
        pengguna_pekerjaan_tagihan,
        pengguna_rhi_kode_ok,
        persentase_biaya,
        presensi,
        presensi_proyek,
        subkon_mangkir,
        project,
        project_pegawai,
        potongan,
        potongan_keterlambatan_proyek,
        rekap_lembur,
        riwayat_pengajuan,
        shift,
        shift_jadwal,
        sppd_proyek,
        tagihan,
        tagihan_biaya,
        tarif_shift,
        tarif_upah,
        tali_asih,
        ter,
        tunjangan,
        tunjangan_lain,
        theme,
        unit_kerja,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
